import React, { useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Card,
  CardContent
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";

const WorkOrdersSection = ({ workOrders }) => {
  const [activeTab, setActiveTab] = useState(0);

  const STATUS_COLORS = {
    in_progress: { color: "#D97706", bg: "#FEF3C7", border: "#FDE68A" },
    completed: { color: "#16A34A", bg: "#DCFCE7", border: "#BBF7D0" },
    pending: { color: "#6B7280", bg: "#F3F4F6", border: "#E5E7EB" },
    cancelled: { color: "#DC2626", bg: "#FEE2E2", border: "#FECACA" },
    overdue: { color: "#DC2626", bg: "#FEE2E2", border: "#FECACA" },
  };

  const PRIORITY_COLORS = {
    critical: { color: "#DC2626", bg: "#FEE2E2", border: "#FECACA" },
    high: { color: "#DC2626", bg: "#FEE2E2", border: "#FECACA" },
    medium: { color: "#D97706", bg: "#FEF3C7", border: "#FDE68A" },
    low: { color: "#16A34A", bg: "#DCFCE7", border: "#BBF7D0" },
  };

  const getStatusConfig = (status) =>
    STATUS_COLORS[status?.toLowerCase()] || STATUS_COLORS.pending;
  const getPriorityConfig = (priority) =>
    PRIORITY_COLORS[priority?.toLowerCase()] || PRIORITY_COLORS.low;

  const filteredOrders =
    activeTab === 0
      ? workOrders
      : activeTab === 1
        ? workOrders.filter((wo) => wo.status !== "completed")
        : workOrders.filter((wo) => wo.status === "completed");

  return (
    <Card sx={{ borderRadius: 1, mb: 3 }}>
      <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AssignmentIcon sx={{ fontSize: 20, color: "text.secondary" }} />
            <Typography
              sx={{ fontWeight: 700, fontSize: "1rem", color: "text.primary" }}
            >
              Work Orders
            </Typography>
          </Box>

          <Tabs
            value={activeTab}
            onChange={(_, val) => setActiveTab(val)}
            sx={{
              minHeight: 32,
              "& .MuiTab-root": {
                minHeight: 32,
                py: 0.5,
                px: 1.5,
                fontSize: "0.75rem",
                fontWeight: 500,
                textTransform: "none",
                color: "#6B7280",
              },
              "& .Mui-selected": { color: "#1B2A3D", fontWeight: 600 },
              "& .MuiTabs-indicator": { bgcolor: "#1B2A3D", height: 2 },
            }}
          >
            Work Orders
          </Tabs>
        </Box>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {[
                  "Work Order",
                  "Title",
                  "Status",
                  "Priority",
                  "Assigned To",
                  "Due Date",
                ].map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      color: "#6B7280",
                      borderBottom: "1px solid #E5E7EB",
                      py: 1.25,
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredOrders.map((wo) => (
                <TableRow
                  key={wo.id}
                  sx={{ "&:last-child td": { borderBottom: 0 } }}
                >
                  <TableCell
                    sx={{
                      fontSize: "0.8125rem",
                      color: "#1B2A3D",
                      fontWeight: 500,
                      py: 1.5,
                    }}
                  >
                    {wo.id}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: "0.8125rem", color: "#1B2A3D", py: 1.5 }}
                  >
                    {wo.title}
                  </TableCell>
                  <TableCell sx={{ py: 1.5 }}>
                    {(() => {
                      const config = getStatusConfig(wo.status);
                      return (
                        <Chip
                          label={wo.status}
                          size="small"
                          sx={{
                            height: 24,
                            fontSize: "0.6875rem",
                            fontWeight: 600,
                            bgcolor: config.bg,
                            color: config.color,
                            border: `1px solid ${config.border}`,
                          }}
                        />
                      );
                    })()}
                  </TableCell>
                  <TableCell sx={{ py: 1.5 }}>
                    {(() => {
                      const config = getPriorityConfig(wo.priority);
                      return (
                        <Chip
                          label={wo.priority}
                          size="small"
                          sx={{
                            height: 24,
                            fontSize: "0.6875rem",
                            fontWeight: 600,
                            bgcolor: config.bg,
                            color: config.color,
                            border: `1px solid ${config.border}`,
                          }}
                        />
                      );
                    })()}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: "0.8125rem", color: "#4B5563", py: 1.5 }}
                  >
                    {wo.assignedTo}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: "0.8125rem", color: "#4B5563", py: 1.5 }}
                  >
                    {wo.dueDate}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default WorkOrdersSection;
